export default [
    { id: '2', name: 'Recaudo por Lote', altName: 'Consulta por Lote' },
    { id: '1', name: 'Recaudo por Cliente', altName: 'Consulta por Cliente' },
]